import MeiliSearch from "meilisearch";

export const Meilisearch = new MeiliSearch({
  host: process.env.NEXT_PUBLIC_MEILISEARCH_HOST as string, // TODO
  apiKey: process.env.NEXT_PUBLIC_MEILISEARCH_API_KEY as string, // TODO 
})


